import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { RetailerSession } from "../../../../models/idpConfig";

const environmentSpecificName = (cookieName: string, env: string): string => {
    if (env === "production") {
        return `${cookieName}`;
    }
    return `${cookieName}-${env}`;
};

export const useGetRetailerSession = (env = "production"): RetailerSession | undefined => {
    const [sessionToken, setSessionToken] = useState<RetailerSession | undefined>();

    useEffect(() => {
        const sessionData = Cookies.get(environmentSpecificName("RETAILER_SESSION", env));
        try {
            if (sessionData) {
                const parsedData = JSON.parse(sessionData);
                setSessionToken(parsedData);
            }
        } catch (error) {
            // Do nothing
        }
    }, []);

    return sessionToken;
};
